import { createRouter, createWebHistory } from 'vue-router';
import HomeView from './views/HomeView.vue';
import Order from './views/OrderView.vue';

const routes = [
    {
        path: '/',
        name: 'HomeView',
        component: HomeView
    },
    {
        path: '/order',
        name: 'Order',
        component: Order
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

export default router; 